export const OTVOREN = 'Otvoren';
export const UOBRADI = 'U obradi';
export const ZAKLJUCAN = 'Zaključan';
export const STORNIRAN = 'Storniran';



// WEBPACK FOOTER //
// ./app/components/radniNalog/statusi.js